<section class="section-pd list-wrapper-style-2 pt-0 pb-40">
    <div class="trinka_container">
        <div class="row justify-content-center">
            <div class="col-lg-12 col-md-12">
                <div class="trinka-title text-center mb-0">
                    <h2>お好みに合わせて<br/>修正案の表示をカスタマイズ</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="section-pd list-wrapper-style-2 pt-0">
    <div class="trinka_container">
        <div class="row align-items-center">
            <div class="col-md-6">
                <div class="list-wrapper-content-2 pr-80">
                    <h3>単語アラート</h3>
                    <p>単語レベルでの修正提案がアラートカードで表示されます。</p>
                    <ul class="bt-list">
                        <li>１枚のカードに１つの修正を表示</li>
                        <li>細かい修正アラートで、丁寧な修正が可能</li>
                        <li>一文一文を正しく書いていくための指針に</li>
                    </ul>
                </div>
            </div>
            <div class="col-md-6">
                <div class="text-center">
                    <video class="vid-video w-100" id="myVideo" playsinline autoplay loop muted oncanplay="this.play()" onloadedmetadata="this.muted = true" >
                        <source src="/assets/images/features/grammar-checker/individual-alerts.mp4" type="video/mp4">
                        Your browser does not support the video element. Kindly update it to latest version.
                    </video>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="list-wrapper-style-2">
    <div class="trinka_container">
        <div class="row align-items-center flex-row-reverse">
            <div class="col-md-6">
                <div class="list-wrapper-content-2">
                    <h3>センテンスアラート</h3>
                    <p>1枚のカードに１文中の修正提案をすべて表示。ワンクリックで全体の承認・却下が可能です。 </p>
                    <ul class="bt-list">
                        <li>1文ごとにまとめて修正して時間を節約</li>
                        <li>少ないカードで見やすい画面に</li>
                        <li>文中の単語レベルの提案の承認・却下も可能 <span class="beta-badges" style="margin-left:5px">近日公開</span></li>
                    </ul>
                </div>
            </div>
            <div class="col-md-6">
                <div class="text-center">
                    <video class="vid-video w-100" id="myVideo" playsinline autoplay loop muted oncanplay="this.play()" onloadedmetadata="this.muted = true" >
                        <source src="/assets/images/features/grammar-checker/sentence-alerts.mp4" type="video/mp4">
                        Your browser does not support the video element. Kindly update it to latest version.
                    </video>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="section-pd list-wrapper-style-2 pb-0">
    <div class="trinka_container">
        <div class="row align-items-center">
            <div class="col-md-6">
                <div class="list-wrapper-content-2 pr-80">
                    <h3>ポップアップ・アラート</h3>
                    <p>ライティングスペースを広めに確保。修正提案のカードはポップアップ形式で表示されます。
                    </p>
                    <ul class="bt-list">
                        <li>ライティングに集中しながら、気になった箇所をカーソルで確認</li>
                        <li>アラートで示される修正提案の承認・却下もワンクリックで可能</li>
                    </ul>
                </div>
            </div>
            <div class="col-md-6">
                <div class="text-center">
                    <video class="vid-video w-100" id="myVideo" playsinline autoplay loop muted oncanplay="this.play()" onloadedmetadata="this.muted = true" >
                        <source src="/assets/images/features/grammar-checker/Bubble-view.mp4" type="video/mp4">
                        Your browser does not support the video element. Kindly update it to latest version.
                    </video>
                </div>
            </div>
        </div>
    </div>
</section>